import { useState } from "react";

export const faqs = [
  {
    question: "What is a passport expediting service?",
    answer: "A private company registered with the U.S. Department of State to submit passport applications directly to federal agencies — bypassing standard mail processing. Registered expediters have reserved daily agency slots, allowing processing in as little as 3 business days instead of the government's 4–6 week standard timeline.",
  },
  {
    question: "How do I know if a passport expediting service is legitimate?",
    answer: "Check the official State Department registry at travel.state.gov. Also verify their BBB rating and look for real physical offices. Fast Passport Center has been on the official registry for 20+ years, holds an A+ BBB rating, and has 24 physical drop-off locations nationwide.",
  },
  {
    question: "What's the difference between a passport expediter and a reseller?",
    answer: "A registered expediter is authorized to directly submit applications to passport agencies. A reseller markets passport services but hands your application to an actual registered expediter — charging you a markup. FedEx Office and Staples are resellers. Fast Passport Center is the registered courier itself.",
  },
  {
    question: "How much does passport expediting service cost?",
    answer: "Fast Passport Center's service fees range from $195 for 9-business-day processing to $345 for 3-business-day processing. Government fees are separate and required regardless of provider. We are typically 20–80% less than retail passport counters for the same processing speed.",
  },
  {
    question: "Can a passport expediter get my passport faster than the government?",
    answer: "A registered courier cannot change the government's processing time — but they guarantee same-day submission using reserved agency slots, eliminating the mail queue delay that adds 1–2 weeks on each end of government processing. The net result is significantly faster door-to-door delivery than DIY processing.",
  },
  {
    question: "Do I still need to visit a passport office?",
    answer: "For renewals (DS-82), no — everything is done by mail. For new passports and lost/stolen replacements (DS-11), you must visit a passport acceptance facility (post office, courthouse, or library) for the in-person signature step. You do NOT need to go to a regional passport agency yourself.",
  },
  {
    question: "What if my application has an error?",
    answer: "Errors cause rejections that add weeks to your timeline. Fast Passport Center's expert document review catches errors before submission. This review step is one of the most important things separating us from lower-cost options that skip it.",
  },
  {
    question: "Can you help if I already have an application in process?",
    answer: "Possibly. Call us at 877-253-0084. Depending on your timeline, we may be able to help escalate or recommend withdrawing and resubmitting through our courier service.",
  },
  {
    question: "Does Fast Passport Center handle visa expediting?",
    answer: "Yes — in addition to U.S. passport expediting, Fast Passport Center handles certain visa services including Chinese business and tourist visas. Call 877-253-0084 or visit our services page for current availability.",
  },
  {
    question: "Why is Fast Passport Center less expensive than FedEx or Staples?",
    answer: "FedEx Office and Staples are resellers — they charge a markup and hand your application to a registered courier like us. You pay their fee plus the courier fee. Using Fast Passport Center directly eliminates the middleman and saves you 20–80% for the same result.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4 text-center">
          Passport Expediting Service — Frequently Asked Questions
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12 text-base md:text-lg">
          Honest answers about how passport expediting works, what to expect, and how to verify any service.
        </p>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-[#D0D7E2] rounded-lg overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-5 text-left bg-[#F7F8FA] hover:bg-[#E8F0FE] transition-colors cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              >
                <span className="font-bold text-[#1A365D] text-sm md:text-base pr-4">{faq.question}</span>
                <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all ${openIndex === i ? "bg-[#1A365D] rotate-45" : "bg-[#D0D7E2]"}`}>
                  <i className={`ri-add-line text-sm ${openIndex === i ? "text-white" : "text-[#1A365D]"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5 text-gray-600 text-sm md:text-base leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 text-[#1A365D] font-bold text-base hover:text-[#4A7AB5] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Still have questions? Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}